export default __webpack_public_path__ + "static/media/MiniTape_SideA_01_Intro.7afe2571.mp3";